export function buildAppLink(lookupCode) {
  return `https://client.medicareplanguardian.com/open/${lookupCode}`;
}

export function copyAppLink(lookupCode) {
  if (!lookupCode) return { ok: false };
  const link = buildAppLink(lookupCode);
  navigator.clipboard.writeText(link);
  return { ok: true, link };
}
